import { defineStore } from 'pinia'
import { ref } from 'vue'
import { toValidLat, toValidLon } from '@/utils/common'
import type { MapType } from '@/types/map'

// 地図モーダルの共通ストア
export const useMapModalStore = defineStore('mapModal', () => {
  const visible = ref(false)
  const lat = ref<number | null>(null)
  const lon = ref<number | null>(null)
  const mapType = ref<MapType>('pale')
  const markerLabel = ref<string | undefined>(undefined)
  const routeWind = ref<boolean>(false)
  const upperWind = ref<boolean>(false)
  let resolver: ((result: { lat: number; lon: number } | null) => void) | null = null

  function open(
    opts: {
      lat?: number | string | null
      lon?: number | string | null
      markerLabel?: string
      routeWind?: boolean
      upperWind?: boolean
    } = {},
  ) {
    lat.value = toValidLat(opts.lat)
    lon.value = toValidLon(opts.lon)
    markerLabel.value = opts.markerLabel
    routeWind.value = !!opts.routeWind
    upperWind.value = !!opts.upperWind
    visible.value = true
    return new Promise<{ lat: number; lon: number } | null>((resolve) => {
      resolver = resolve
    })
  }

  function close() {
    visible.value = false
    resolver = null
  }

  function applyPosition() {
    visible.value = false
    if (lat.value != null && lon.value != null) {
      resolver?.({ lat: lat.value, lon: lon.value })
    } else {
      resolver?.(null)
    }
    resolver = null
  }

  function cancel() {
    visible.value = false
    resolver?.(null)
    resolver = null
  }

  function setMapType(type: MapType) {
    mapType.value = type
  }

  return {
    visible,
    lat,
    lon,
    mapType,
    markerLabel,
    routeWind,
    upperWind,
    close,
    open,
    applyPosition,
    cancel,
    setMapType,
  }
})
